var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",on:{"click":_vm.goBack}},[_c('feather',{staticClass:"back-icon",attrs:{"type":"arrow-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }